import React from 'react';
import PropTypes from 'prop-types';

class SubHeading extends React.PureComponent {
    render() {
        const { children, small } = this.props;
        const fontSize = small ? '16px' : '18px';

        return <p style={{ fontSize }}>{children}</p>;
    }
}

SubHeading.propTypes = {
    children: PropTypes.node.isRequired,
    small: PropTypes.bool,
};

SubHeading.defaultProps = {
    small: false,
};

export default SubHeading;
